var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconWebform18 = function SvgAIconWebform18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5031 10.2961L10.4008 16.4L7.40039 17L8.00046 14.0001L14.106 7.8962C14.4232 7.57852 14.8536 7.39999 15.3026 7.39999C15.7515 7.39999 16.182 7.57852 16.4991 7.8962L16.5063 7.9026C17.1663 8.5645 17.1649 9.63601 16.5031 10.2961Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.6H2.06667C1.47756 14.6 1 14.1316 1 13.5538V2.04615C1 1.46838 1.47756 1 2.06667 1H12.7333C13.3224 1 13.8 1.46838 13.8 2.04615V5",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 4.60001H8.2002",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 7.79999H9.8002",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconWebform18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNTAzMSAxMC4yOTYxTDEwLjQwMDggMTYuNEw3LjQwMDM5IDE3TDguMDAwNDYgMTQuMDAwMUwxNC4xMDYgNy44OTYyQzE0LjQyMzIgNy41Nzg1MiAxNC44NTM2IDcuMzk5OTkgMTUuMzAyNiA3LjM5OTk5QzE1Ljc1MTUgNy4zOTk5OSAxNi4xODIgNy41Nzg1MiAxNi40OTkxIDcuODk2MkwxNi41MDYzIDcuOTAyNkMxNy4xNjYzIDguNTY0NSAxNy4xNjQ5IDkuNjM2MDEgMTYuNTAzMSAxMC4yOTYxWiIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTUgMTQuNkgyLjA2NjY3QzEuNDc3NTYgMTQuNiAxIDE0LjEzMTYgMSAxMy41NTM4VjIuMDQ2MTVDMSAxLjQ2ODM4IDEuNDc3NTYgMSAyLjA2NjY3IDFIMTIuNzMzM0MxMy4zMjI0IDEgMTMuOCAxLjQ2ODM4IDEzLjggMi4wNDYxNVY1IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNC4yMDAyIDQuNjAwMDFIOC4yMDAyIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNC4yMDAyIDcuNzk5OTlIOS44MDAyIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";